import { render, staticRenderFns } from "./GymSpaceListItem.vue?vue&type=template&id=8696913c"
import script from "./GymSpaceListItem.vue?vue&type=script&lang=js"
export * from "./GymSpaceListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports